import { render, staticRenderFns } from "./SelectSchemaBusiness.vue?vue&type=template&id=4127f721&scoped=true"
import script from "./SelectSchemaBusiness.vue?vue&type=script&lang=js"
export * from "./SelectSchemaBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127f721",
  null
  
)

export default component.exports